import * as React from "react";
// Utilities
import { ActionButton } from "@fluentui/react";
/**
 * Icon Indicator button component
 */ export const IconIndicator = (props)=>/*#__PURE__*/ React.createElement(ActionButton, {
        "aria-label": props.ariaLabel,
        tabIndex: props.isKeyboardFocusable ? 0 : -1,
        "data-is-focusable": props.isKeyboardFocusable,
        title: props.ariaLabel,
        ...props
    }, props.label);
